var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 11,
    viewBox: "0 0 34 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.245 0.608077L12.5691 10.466H15.2505L16.9266 0.608077H14.245ZM10.313 0.608077L7.7565 7.3883L7.45409 5.92828L7.45431 5.92876L7.38767 5.60152C7.07826 4.96332 6.36167 3.75035 5.00856 2.71519C4.60852 2.40921 4.20526 2.14808 3.81543 1.92502L6.1389 10.466H8.9327L13.199 0.608077H10.313ZM20.7781 3.34484C20.7781 2.23031 23.3895 2.37353 24.537 2.97871L24.9196 0.861484C24.9196 0.861484 23.7387 0.431641 22.5078 0.431641C21.177 0.431641 18.017 0.988633 18.017 3.69505C18.017 6.24212 21.7259 6.27377 21.7259 7.61102C21.7259 8.94826 18.3994 8.70928 17.3017 7.86572L16.9027 10.0787C16.9027 10.0787 18.1 10.6357 19.9298 10.6357C21.7593 10.6357 24.5203 9.72852 24.5203 7.26081C24.5203 4.69781 20.7781 4.4591 20.7781 3.34484ZM31.7201 0.608077H29.5642C28.5687 0.608077 28.3263 1.34273 28.3263 1.34273L24.3274 10.466H27.1223L27.6814 9.00186H31.0903L31.4048 10.466H33.8669L31.7201 0.608077ZM28.4541 6.9789L29.8632 3.28981L30.6558 6.9789H28.4541Z",
    fill: "#005BAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58873 1.53618C6.58873 1.53618 6.47774 0.646484 5.29283 0.646484H0.987925L0.9375 0.813691C0.9375 0.813691 3.00678 1.21742 4.99199 2.73001C6.88914 4.17567 7.50802 5.97776 7.50802 5.97776L6.58873 1.53618Z",
    fill: "#F6AC1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.32bec431adcab2f28b4d2a529ad0d70c.svg";
export { ForwardRef as ReactComponent };